import { memo } from 'react'
import { Text } from 'common-components'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import LanguageDropdown from 'containers/SubSidebar/shared/Voices/LanguageDropdown'
import SpeakerDropdown from 'containers/SubSidebar/shared/Voices/SpeakerDropdown'
import SpeakerVelocity from 'containers/SubSidebar/shared/Voices/Velocity'
import { AvatarVoiceTab } from 'store/types/aiAvatar'
import VoiceTabs from './VoiceTabs'
import VoiceCloneTab from './VoiceCloneTab'
import { useAvatarVoice } from './useAvatarVoice'
import * as Styled from './styled'

// Speed (voice velocity) control is hidden for the first AI Avatar release.
// Flip to `true` to bring it back — all wiring (speed state + handler) is kept intact.
const SHOW_VOICE_SPEED = false

const VoiceSection: React.FC = () => {
  const {
    languageOptions,
    isLanguageOptionsLoading,
    langCode,
    speakerId,
    speed,
    activeVoiceTab,
    ttsSpeakers,
    isSpeakersLoading,
    onChooseLanguageOption,
    onChooseSpeakerOption,
    onChooseSpeedOption,
    onVoiceTabChange
  } = useAvatarVoice()

  return (
    <Styled.VoiceSectionContainer>
      <Text
        style={{ marginBottom: '-4px' }}
        type="subtitle"
        color="secondaryDark"
      >
        {translate(T.VOICES_LABEL)}
      </Text>

      <LanguageDropdown
        isDataLoading={isLanguageOptionsLoading}
        languageOptions={languageOptions}
        selectedLanguageId={langCode}
        onLanguageChange={onChooseLanguageOption}
      />

      <VoiceTabs activeTab={activeVoiceTab} onTabChange={onVoiceTabChange} />

      {activeVoiceTab === AvatarVoiceTab.LIBRARY ? (
        <Styled.SpeakerRow>
          <SpeakerDropdown
            isDataLoading={isSpeakersLoading}
            speakersData={ttsSpeakers}
            selectedSpeakerId={speakerId}
            onSpeakerClick={onChooseSpeakerOption}
          />
          {SHOW_VOICE_SPEED && (
            <SpeakerVelocity
              isBulkMode
              initialValue={speed}
              onClick={onChooseSpeedOption}
            />
          )}
        </Styled.SpeakerRow>
      ) : (
        <VoiceCloneTab />
      )}
    </Styled.VoiceSectionContainer>
  )
}

export default memo(VoiceSection)
